import { useCallback, useEffect, useReducer, useState } from "react";
import { actionConsts, reducer } from "./StateManager";
import { CustomAlertDialog } from "./CustomAlertDialog";
import { HbrCancel } from "./Mycustomsvgicons";
import { formatMediaTime } from "./GeneralClasses";

export const CustomConfirmDialog = ({formDesc, hint, positiveBtn, title, callback, closeDialog, showTimer}) => {

    const [inputValue,setInputValue]=useState("");
    const [tries,setTries]=useState(180);
    const [state,dispatch]=useReducer(reducer,{alertMessage: "", showAlert: false});

    const handleValidateUser=(e)=>{
        e.preventDefault();
        callback(inputValue);
        closeDialog();
    }

    useEffect(()=>{
        if (showTimer) {
            const intervalId = setInterval(() => {
                setTries(prev => prev - 1);
            }, 1000);
            return()=>clearInterval(intervalId);
        }
    },[showTimer]);

    const blockValidationProcess=useCallback(()=>{
        if (tries === 0) {
            closeDialog();
        }
    },[tries, closeDialog]);

    useEffect(()=>{
        blockValidationProcess();
    },[blockValidationProcess]);


    return ( 
        <div className="confirmdialog flex-column2" style={{
            height:"auto",
            maxHeight:"400px",
            backgroundColor:"#1C1F2E",
            borderRadius:"10px",
            boxShadow:"0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.23)",
        
        }}>
        {state.showAlert &&
            <CustomAlertDialog alertmessage={state.alertMessage} handleCloseDialog={()=>dispatch({type: actionConsts.SHOWALERT,payload: false})}/>
          }
            <div className="flex-spacearound" style={{width:"100%"}}>
                <h2 style={{color:"white"}}>{title}</h2>
                <HbrCancel width="2em" height="2em" fillColour="white" handleClick={()=>closeDialog()}/>
            </div>
           
            <p style={{color:"white"}}>{formDesc? formDesc : ""}</p>
            {showTimer && <h4 style={{color: "white"}}>Time remaining: {formatMediaTime(tries)}</h4>}
            <form onSubmit={handleValidateUser} className="flex-column2"
            style={{
                width:"90%",
                padding:"10px",
                gap:"20px",
                backgroundColor:"#252a41"
            }}>
                <input type="text" placeholder={hint} required value={inputValue} onChange={e => setInputValue(e.target.value.trim())} 
                style={{
                    borderRadius:"999px",
                    width:"80%",
                    padding:"8px",
                    border:"none",
                    fontSize:"1.2em",
                    outline:"none"
                }}
                />
                <button style={{border:"none",borderRadius:"10px", backgroundColor:"#0E78F9",color:"white",fontWeight:"bold",cursor:"pointer",padding:"10px",caretColor:"transparent"}}>
                    {positiveBtn}
                </button>
            </form>
        </div>
     );
}